import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

import { ref, computed, watch } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import InputWithUnit from '@/components/InputWithUnit.vue'
import SelectOperator from '@/components/SelectOperator.vue'
import SelectStation from '@/components/SelectStation.vue'
import SelectEvseModel from '@/components/SelectEvseModel.vue'
import InfoTooltip from '@/components/InfoTooltip.vue'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { getEvseModelInfo, upsertEvse } from '@/api/evses'
import { ElMessage } from 'element-plus'
import FormRulesFactory from '@/common/formRules'
import AdvancedSettingContainer from '@/components/AdvancedSettingContainer.vue'


import { defineComponent, nextTick } from 'vue'
import { cloneDeep, omit, pick } from 'lodash'

const __default__ = defineComponent({
  name: 'EvseDrawer',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  opeartorID: {
    type: String,
    default: '',
  },
  stationID: {
    type: String,
    default: '',
  },
  isEdit: {
    type: Boolean,
  },
  evseInfo: {
    type: Object,
    default() {
      return {}
    },
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { expose, emit }) {

const props = __props

const evseFormRules = ref({
  ...FormRulesFactory.generateCustomRules(
    [
      'operatorID',
      'operationType',
      'connectorType',
      'modelId',
      'standard',
      'evseCurrentType',
      'useVehicleType',
      'netType',
      'chargingSpeedType',
    ],
    'selectNone',
    'selectNone',
  ),
  ...FormRulesFactory.generateCustomRules(
    ['evseSN', 'model', 'vendor'],
    'inputEmpty',
    'inputInvalid',
  ),
  ...FormRulesFactory.generateCustomRules(['connectorNum'], 'inputEmpty', 'inputInvalid', {
    type: 'number',
    min: 1,
    max: 20,
    pattern: /^[1-9][0-9]*$/,
  }),
  ...FormRulesFactory.generateCustomRules(['ratedPower'], 'inputEmpty', 'inputInvalid', {
    type: 'number',
    min: 1,
    max: 1000,
  }),
  ...FormRulesFactory.generateCustomRules(
    ['minCurrent', 'maxCurrent'],
    'inputEmpty',
    'inputInvalid',
    {
      type: 'number',
      min: 1,
      max: 500,
    },
  ),
  ...FormRulesFactory.generateCustomRules(['ratedVoltage'], 'inputEmpty', 'inputInvalid', {
    type: 'number',
    min: 1,
    max: 2000,
  }),
})
// console.log('🚀 ~ evseFormRules:', evseFormRules.value)

const {
  evseOperationTypes,
  connectorTypes,
  evseStandards,
  evseCurrentTypes,
  useVehicleTypes,
  evseNetworkingModes,
  evseChargingSpeedType,
  evsePhases,
  evseFuncs,
} = useProtocolEnums()

const { tl, t } = useI18nTl('Evses')



let subsForm = ref()
const record = ref<Record<string, any>>({})
const clearValidate = () => {
  console.log('clearValidate')
  nextTick(() => {
    let t = setTimeout(() => {
      clearTimeout(t)
      subsForm.value?.clearValidate()
    }, 300)
  })
}
const showDialog = computed({
  get: () => {
    clearValidate()
    return props.modelValue
  },
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})
const handleOperatorSelect = (item: any) => {
  console.log('item======== operator select', item)
  record.value.stationID = ''
  record.value.stationName = ''
}
const stationSelect = (item: any) => {
  record.value.stationName = item.name
}
const submit = async () => {
  await subsForm.value?.validate()
  const processedRecord = ref({ ...record.value })
  processedRecord.value.ratedPower = Number(
    processedRecord.value.ratedPower.substring(0, processedRecord.value.ratedPower.length - 2),
  )
  processedRecord.value.ratedVoltage = Number(
    processedRecord.value.ratedVoltage.substring(0, processedRecord.value.ratedVoltage.length - 1),
  )
  processedRecord.value.minCurrent = Number(
    processedRecord.value.minCurrent.substring(0, processedRecord.value.minCurrent.length - 1),
  )
  processedRecord.value.maxCurrent = Number(
    processedRecord.value.maxCurrent.substring(0, processedRecord.value.maxCurrent.length - 1),
  )

  if (processedRecord.value.modelId == '') {
    processedRecord.value.modelId = '0'
  }
  if (processedRecord.value.stationID == '') {
    processedRecord.value.stationID = '0'
  }

  if (processedRecord.value.minCurrent >= processedRecord.value.maxCurrent) {
    ElMessage.error(t(`formRules.minCurrentLessThanMaxCurrent`))
    return
  }

  upsertEvse(processedRecord.value)
    .then((res: any) => {
      if (props.isEdit) {
        ElMessage.success(t(`Base.editSuccess`))
      } else {
        ElMessage.success(t(`Base.createSuccess`))
      }

      showDialog.value = false
      record.value = {}
      emit('submitted')
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
    })
}

watch(
  () => props.modelValue,
  (val) => {
    if (props.isEdit) {
      console.log('props.evseInfo', props.evseInfo)
      // record.value.id = props.evseInfo?.id
      // record.value.operatorID = props.evseInfo?.operatorID
      // record.value.stationID = props.evseInfo?.stationID
      // record.value.stationName = props.evseInfo?.stationName //stationName 将站点修改成站点名称

      // record.value.operationType = props.evseInfo?.operationType
      // record.value.connectorType = props.evseInfo?.connectorType
      // record.value.modelId = props.evseInfo?.modelId
      // record.value.model = props.evseInfo?.model
      // record.value.vendor = props.evseInfo?.vendor
      // record.value.product = props.evseInfo?.product
      // record.value.standard = props.evseInfo?.standard
      // record.value.phase = props.evseInfo?.phase
      // record.value.speedType = props.evseInfo?.speedType
      // record.value.evseCurrentType = props.evseInfo?.evseCurrentType
      // record.value.useVehicleType = props.evseInfo?.useVehicleType
      // record.value.netType = props.evseInfo?.netType
      record.value = cloneDeep(
        pick(props.evseInfo, [
          'id',
          'operatorID',
          'stationID',
          'stationName',
          'operationType',
          'connectorType',
          'modelId',
          'model',
          'vendor',
          'product',
          'standard',
          'phase',
          'chargingSpeedType',
          'evseCurrentType',
          'useVehicleType',
          'netType',
        ]),
      )
      // 检查stationID是否为0，如果是则设置为空字符串
      if (record.value.stationID === '0') {
        record.value.stationID = '';
        record.value.stationName = '';
      }
      record.value.funcs = props.evseInfo?.functions
      record.value.evseSN = props.evseInfo?.sn
      record.value.operationType = props.evseInfo?.evseOperationType
      record.value.connectorNum = props.evseInfo?.connectorNumber

      record.value.model = props.evseInfo?.evseModel?.model
      record.value.vendor = props.evseInfo?.evseModel?.vendor
      record.value.product = props.evseInfo?.evseModel?.product
      record.value.standard = props.evseInfo?.evseModel?.standard
      record.value.evseCurrentType = props.evseInfo?.evseModel?.evseCurrentType
      record.value.useVehicleType = props.evseInfo?.evseModel?.useVehicleType
      record.value.netType = props.evseInfo?.evseModel?.networking
      record.value.phase = props.evseInfo?.evseModel?.phase
      record.value.ratedPower = String(props.evseInfo?.evseModel?.ratedPower / 1000) + 'KW'
      record.value.ratedVoltage = String(props.evseInfo?.evseModel?.ratedVoltage) + 'V'
      record.value.minCurrent = String(props.evseInfo?.evseModel?.ratedCurrentMin) + 'A'
      record.value.maxCurrent = String(props.evseInfo?.evseModel?.ratedCurrentMax) + 'A'
    } else {
      record.value = {
        operatorID: props.opeartorID,
        stationID: props.stationID,
      }
    }
  },
  { immediate: true },
)

const selectionEvseModelChanged = (modelId: string) => {
  // 在这里处理选中后的逻辑，例如发送网络请求、更新数据等
  if (modelId && modelId != '0' && modelId != '') {
    // console.log('选中的模型ID：', modelId)
    getEvseModelInfo({
      modelId: modelId,
    })
      .then((res: any) => {
        // console.log('选中的模型：', res)
        record.value.model = res.model.model
        record.value.vendor = res.model.vendor
        record.value.product = res.model.product
        record.value.standard = res.model.standard
        record.value.evseCurrentType = res.model.evseCurrentType
        record.value.useVehicleType = res.model.useVehicleType
        record.value.netType = res.model.networking
        record.value.phase = res.model.phase
        record.value.ratedPower = String(res.model.ratedPower / 1000) + 'KW'
        record.value.ratedVoltage = String(res.model.ratedVoltage) + 'V'
        record.value.minCurrent = String(res.model.ratedCurrentMin) + 'A'
        record.value.maxCurrent = String(res.model.ratedCurrentMax) + 'A'
      })
      .catch((error: any) => {
        console.error('Error fetching table data:', error)
      })
  }
}
expose({
  clearValidate,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: props.isEdit ? _unref(tl)('editEvse') : _unref(tl)('addEvse'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "50%",
    "z-index": 1999,
    "custom-class": "evse-drawer",
    "destroy-on-close": true
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[21] || (_cache[21] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.isEdit ? _ctx.$t('Base.edit') : _ctx.$t('Base.add')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        rules: evseFormRules.value,
        ref_key: "subsForm",
        ref: subsForm
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "evseSN",
                    required: ""
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("label", null, _toDisplayString(_unref(tl)('evseSN')), 1),
                      _createVNode(InfoTooltip, {
                        content: _ctx.$t('Evses.addEvseTip'),
                        place: _ctx.left
                      }, null, 8, ["content", "place"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: 1,
                        modelValue: record.value.evseSN,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.evseSN) = $event)),
                        disabled: props.isEdit
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "operatorID",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectOperator, {
                        modelValue: record.value.operatorID,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.operatorID) = $event)),
                        disabled: props.isEdit,
                        onChanges: handleOperatorSelect
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.station'),
                    prop: "stationID"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectStation, {
                        modelValue: record.value.stationID,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.stationID) = $event)),
                        operatorID: record.value.operatorID,
                        name: record.value.stationName,
                        disabled: record.value.operatorID == '0' || !record.value.operatorID,
                        onChange: stationSelect
                      }, null, 8, ["modelValue", "operatorID", "name", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('connectorNum'),
                    prop: "connectorNum",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        max: 20,
                        min: 1,
                        modelValue: record.value.connectorNum,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((record.value.connectorNum) = $event)),
                        placeholder: "1"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('speedType'),
                    prop: "chargingSpeedType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.chargingSpeedType,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((record.value.chargingSpeedType) = $event)),
                        clearable: "",
                        prop: "chargingSpeedType"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseChargingSpeedType), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('operationType'),
                    prop: "operationType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.operationType,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((record.value.operationType) = $event)),
                        clearable: "",
                        prop: "operationType"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseOperationTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('connectorType'),
                    prop: "connectorType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.connectorType,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((record.value.connectorType) = $event)),
                        clearable: "",
                        prop: "connectorType"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(connectorTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }),
              _createVNode(AdvancedSettingContainer, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _unref(tl)('function'),
                        prop: "funcs"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("label", null, _toDisplayString(_unref(tl)('function')), 1),
                          _createVNode(InfoTooltip, {
                            content: _ctx.$t('Evses.functionTips')
                          }, null, 8, ["content"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: record.value.funcs,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((record.value.funcs) = $event)),
                            clearable: "",
                            multiple: "",
                            prop: "funcs"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseFuncs), (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.label,
                                  value: item.value,
                                  key: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_divider)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('inputEvseModle')
                  }, null, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(SelectEvseModel, {
                    modelValue: record.value.modelId,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((record.value.modelId) = $event)),
                    operatorID: record.value.operatorID,
                    name: record.value.model,
                    disabled: 
              record.value.operatorID == '0' || record.value.operatorID == '' || record.value.operatorID == undefined
            ,
                    placeholder: _unref(tl)('selectEvseModle'),
                    onChange: selectionEvseModelChanged
                  }, null, 8, ["modelValue", "operatorID", "name", "disabled", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('model'),
                    prop: "model",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.model,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((record.value.model) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('vendor'),
                    prop: "vendor",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.vendor,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((record.value.vendor) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('product'),
                    prop: "product"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.product,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((record.value.product) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('standard'),
                    prop: "standard",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.standard,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((record.value.standard) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseStandards), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('phase')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.phase,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((record.value.phase) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evsePhases), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('evseCurrentType'),
                    prop: "evseCurrentType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.evseCurrentType,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((record.value.evseCurrentType) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseCurrentTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('useVehicleType'),
                    prop: "useVehicleType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.useVehicleType,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((record.value.useVehicleType) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(useVehicleTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('networking'),
                    prop: "netType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.netType,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((record.value.netType) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseNetworkingModes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('ratedPower'),
                    prop: "ratedPower",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(InputWithUnit, {
                        modelValue: record.value.ratedPower,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((record.value.ratedPower) = $event)),
                        "number-placeholder": "7",
                        units: [{ label: 'KW', value: 'KW' }]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('ratedVoltage'),
                    prop: "ratedVoltage",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(InputWithUnit, {
                        modelValue: record.value.ratedVoltage,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((record.value.ratedVoltage) = $event)),
                        "number-placeholder": "380",
                        units: [{ label: 'V', value: 'V' }]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('minCurrent'),
                    prop: "minCurrent",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(InputWithUnit, {
                        modelValue: record.value.minCurrent,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((record.value.minCurrent) = $event)),
                        "number-placeholder": "8",
                        units: [{ label: 'A', value: 'A' }]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('maxCurrent'),
                    prop: "maxCurrent",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(InputWithUnit, {
                        modelValue: record.value.maxCurrent,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((record.value.maxCurrent) = $event)),
                        "number-placeholder": "40",
                        units: [{ label: 'A', value: 'A' }]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})